import { defineComponent as _defineComponent } from 'vue'
import { computed, useSlots } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CModal',
  props: {
    value: { type: Boolean },
    size: { default: 'md' },
    title: null,
    autoFocus: { type: Boolean, default: false },
    okTitle: { default: 'Ok' },
    okDisabled: { type: Boolean, default: false },
    hideClose: { type: Boolean },
    hideFooter: { type: Boolean, default: false },
    scrollable: { type: Boolean, default: true },
    hideBackdrop: { type: Boolean },
    dialogClass: null
  },
  emits: ["input", "ok", "closed"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: boolean): void;
    (event: 'ok'): void;
    (event: 'closed'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, size: string, title?: string, autoFocus: boolean, okTitle: string, okDisabled: boolean, hideClose?: boolean, hideFooter: boolean, scrollable: boolean, hideBackdrop?: boolean, dialogClass?: string };

/**
 * Bootstrap Vanilla component doesn't work properly in angular views, so we made a wrapper
 * component for bootstrap-vue modal in order to change only this component
 * after upgrade to vue 3 and remove bootstrap-vue
 */


const slots = useSlots();



const isOpen = computed({
    get(): boolean {
        return props.value;
    },
    set(value: boolean) {
        emit('input', value);
    }
});

return { __sfc: true,emit, slots, props, isOpen }
}

})